// extracted by mini-css-extract-plugin
module.exports = {"container":"MobileTabletImage_container__1yJfA","parralax":"MobileTabletImage_parralax__3hAQH","cardImageWrapper":"MobileTabletImage_cardImageWrapper__ORP-o"};